// extracted by mini-css-extract-plugin
export default {"info_block":"style_info_block__ziFAT","text":"style_text__3tziD"};